import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';

const IssuableHeader = () => {
  return (
    <Table sx={{ width: '100%', height: 'auto' }}>
      <TableHead>
        <TableRow sx={{
          bgcolor: '#F7F7F7',
          borderBottom: '1px solid #F2F2F2'
        }}>
          <TableCell sx={{ width: '20%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Item Name
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '20%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Project Name
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '15%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Issue Date
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '15%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Return Date
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '9%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Quantity
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '10%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Picked
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '15%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Returned
            </TableSortLabel>
          </TableCell>
          <TableCell sx={{ width: '5%', textAlign: 'center', padding: '0.875rem 0.75rem', borderBottom: '1px solid #F2F2F2' }}>
            <TableSortLabel hideSortIcon sx={{ color: '#5C5C5C', fontWeight: '500', fontSize: '20px', lineHeight: '20px' }}>
              Action
            </TableSortLabel>
          </TableCell>
        </TableRow>
      </TableHead>
    </Table>
  );
};

export default IssuableHeader;
